import React, { useEffect, useState } from "react";
import BodyMain from "../../components/util/BodyMain";
import { Badge, Button, Box, IconButton, Typography, Divider, Stack } from "@mui/material";

import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { constants } from '../../util'
import { deleteAlbum, getAlbumList, publishAlbum } from "../../services/albumService";

import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { esES, enUS } from '@mui/x-data-grid/locales';
import ChatIcon from '@mui/icons-material/Chat';
import MenuIcon from '@mui/icons-material/Menu';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import PreviewIcon from '@mui/icons-material/Preview';
import VisibilityIcon from '@mui/icons-material/Visibility';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import HomeIcon from '@mui/icons-material/Home';
import Confirmation from "../../components/message/confirmation";
import { showWaiting } from "../../store/slices/configSlice";
import { enqueueSnackbar } from 'notistack';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import Chat from "./chat";


const Songs = () => {
    //TRANSLATION
    const [t, i18n] = useTranslation("global");
    const {language} = useSelector(state => state.configuration);

    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [currentAlbumId, setCurrentAlbumId] = useState(null);
    const [currentAlbumName, setCurrentAlbumName] = useState(null);
    const [currentAlbumDisabled, setCurrentAlbumDisabled] = useState(false);
    
    const [currentItemAsAlbum, setCurrentItemAsAlbum] = useState(null);
    const [currentItemPublished, setCurrentItemPublished] = useState(false);
    
    const [result, setResult] = useState(undefined);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [showConfirmPublish, setShowConfirmPublish] = useState(false);
    const [showMessagesPopup, setShowMessagesPopup] = useState(false);
    const [selectedItemDelete, setSelectedItemDelete] = useState(-1);    
    const {deviceType} = useSelector(state => state.configuration);
    const navigate = useNavigate();
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);


    const handleClick_Delete = (id) =>{
        setShowConfirmDelete(true);
        // setSelectedItemDelete(id)
    }

    const columns = [
        {
            field: 'albumId',
            description: '',
            headerName: '',
            type: 'string',
            width: 60,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%', height:'100%',
                            display:'flex',
                            justifyContent:'center',
                            alignContent:'center'
                            }}
                    >
                        <div>
                            <IconButton 
                                color="primary"
                                onClick={(e) => handleClickMenu(e, params.row.albumId, params.row.isAlbum, params.row.status)} // Función para editar
                                aria-label="Editar"
                                // sx={{alignSelf:'center', placeSelf:'center'}}
                            >
                                <MenuIcon fontSize="large" />
                            </IconButton>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'albumPhoto',
            description: t("songs.gridColumn1"),
            headerName: t("songs.gridColumn1"),
            type: 'string',
            width: 120,
            headerAlign: 'left',
            renderCell: (params) => {
                // Si la URL está vacía, puedes mostrar un placeholder o nada
                if (!params.value) return null;
                
                return (
                    <div style={{width:'100%', display:'flex', justifyContent:'center'}}>
                        <img 
                            src={params.value}
                            alt="Album cover" 
                            style={{ 
                                width: '100px', 
                                height: '100px',
                                objectFit: 'cover',
                                borderRadius: '4px'
                            }} 
                        />
                    </div>
                );
            }
        },
        {
            field: 'b',
            description: t("songs.gridColumn2"),
            headerName: t("songs.gridColumn2"),
            type: 'string',
            width: 160,
            headerAlign: 'left',
            renderCell: (params) => (
                <div style={{ width: '100%', height:'100%', 
                        display:'flex',
                        justifyContent:'flex-start', 
                    }}
                >
                    <div style={{alignSelf:'center'}}>
                        <strong style={{ color: '#667', fontSize: '0.8rem' }}>{params.row.title}</strong>
                        {/* <div style={{ color: '#666', fontSize: '0.8rem' }}>{params.row.mainArtist}</div> */}
                        <div style={{ color: '#667', fontSize: '0.7rem' }}>{params.row.launchingDate.substring(0,10)}</div>
                        <div style={{ color: '#667', fontSize: '0.7rem' }}>{params.row.isAlbum ? 
                                                                    (language==='es' ? `Álbum (${params.row.numSongs})` : `Album (${params.row.numSongs})`) : (language==='es' ? 'Canción' : 'Single song')}</div>
                    </div>
                </div>
            ),
        },
        {
            field: 'c',
            description: t("songs.gridColumn3"),
            headerName: t("songs.gridColumn3"),
            type: 'string',
            width: 140,
            headerAlign: 'left',
            renderCell: (params) => (
                <div style={{ width: '100%', height:'100%', 
                        display:'flex',
                        justifyContent:'flex-start', 
                    }}
                >
                    <div style={{alignSelf:'center'}}>
                        <strong style={{ color: '#667', fontSize: '0.7rem' }}>{params.row.mainArtist}</strong>
                        <div style={{ color: '#667', fontSize: '0.7rem' }}>{params.row.creator}</div>
                        <div style={{ color: '#667', fontSize: '0.7rem' }}>{params.row.producer}</div>
                    </div>
                </div>
            ),
        },
        {
            field: 'status',
            description: t("songs.gridColumn4"),
            headerName: t("songs.gridColumn4"),
            type: 'string',
            width: 140,
            headerAlign: 'left',
            renderCell: (params) => (
                <div style={{width:'100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <div style={{
                        backgroundColor: params.row.colorStatus==='yellow' ? '#FFFB95' : ( params.row.colorStatus==='green' ? '#95FFA6' : ( params.row.colorStatus==='blue' ? '#DDE6FF' : '#FFC7C7')),
                        border: params.row.colorStatus==='yellow' ? '1px solid #CBA600' : ( params.row.colorStatus==='green' ? '1px solid #009C17' : ( params.row.colorStatus==='blue' ? '1px solid #0136BD' : '1px solid #C00000')),
                        width:'70%',
                        height:'30px',
                        textAlign:'center',
                        alignContent:'center',
                        borderRadius:'7px',
                        color: '#667', 
                        fontSize: '0.7rem',
                        fontWeight: 'bold',
                    }}>
                        {
                            language==='es' && params.value==='Pending' 
                                ? "Pendiente"
                                : language==='es' && params.value==='Approved' 
                                    ? "Aprobado"
                                    : language==='es' && params.value==='Rejected' 
                                        ? "Rechazado"
                                        : language==='es' && params.value==='Published' 
                                            ? "Publicado"
                                            : language==='en' && params.value==="Pendiente" 
                                                ? "Pending"
                                                : language==='en' && params.value==='Aprobado' 
                                                    ? "Approved"
                                                    : language==='en' && params.value==='Rechazado' 
                                                        ? "Rejected"
                                                        : language==='en' && params.value==='Publicado' 
                                                            ? "Published"
                                                            : params.value
                        }
                    </div>
                </div>
            )
        },
        {
            field: 'ba',
            description: t("songs.gridColumn5"),
            headerName: t("songs.gridColumn5"),
            type: 'string',
            width: 140,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%',  height:'100%', display:'flex', justifyContent:'center', alignContent:'center'}}>
                        <div style={{alignSelf:'center', textAlign:'center'}}>
                            <IconButton 
                                color="primary"
                                onClick={() => handleViewMessages(params.row.albumId, params.row.title, params.row.colorStatus==='red')}
                                aria-label="Editar"
                            >
                                <Badge badgeContent={params.row.numSongsNotSeen} color="error">
                                    <ChatIcon fontSize="large" />
                                </Badge>
                            </IconButton>
                            <div style={{width:'100%', textAlign:'center', color: '#667', fontSize: '0.8rem'}}>{t("songs.gridOption1")}</div>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'za',
            description: t("songs.gridColumn7"),
            headerName: t("songs.gridColumn7"),
            type: 'string',
            width: 140,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%',  height:'100%', 
                        display:params.row.status==='Publicado' || params.row.status==='Published' ? 'none' : 'flex', 
                        justifyContent:'center', alignContent:'center'}}>
                        <div style={{alignSelf:'center', textAlign:'center'}}>
                            <IconButton 
                                color="primary"
                                onClick={() => clickOptionPublish(params.row.albumId)}
                                aria-label="Editar"
                            >
                                <SendOutlinedIcon fontSize="large" />
                            </IconButton>
                            <div style={{width:'100%', textAlign:'center', color: '#667', fontSize: '0.8rem'}}>
                                {t("songs.gridColumn7")}
                            </div>
                        </div>
                    </div>
                );
            }
        },
    ];


    const handleDelete = (responseDelete) => {
            if (responseDelete){
                dispatch(showWaiting(true));
    
                deleteAlbum(
                    currentAlbumId,
                ).then(
                    (rsp) => {
                        setTimeout(() => {
                            getAlbumList(null)
                                .then((rsp) => {
                                    setRows(rsp.metadata)
                                });
                    
                            enqueueSnackbar(rsp.message, 
                                { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                            dispatch(showWaiting(false));
                        }, 1000);
                    }
                );
            }
        }

    
    const clickOptionPublish = (itemId) => {
        setCurrentAlbumId(itemId);
        setShowConfirmPublish(true);
    }
    
    
    const handlePublish = (responsePublish) => {
            if (responsePublish){
                dispatch(showWaiting(true));
    
                publishAlbum(
                    currentAlbumId,
                ).then(
                    (rsp) => {
                        setTimeout(() => {
                            getAlbumList(null)
                                .then((rsp) => {
                                    setRows(rsp.metadata)
                                });
                    
                            enqueueSnackbar(rsp.message, 
                                { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                            dispatch(showWaiting(false));
                        }, 1000);
                    }
                )
                .catch(err => {
                    enqueueSnackbar("error", 
                        { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                    dispatch(showWaiting(false));
                });
            }
        }


    const handleClickMenu = (event, id, isAlbum, status) => {
        setAnchorEl(event.currentTarget);
        setCurrentAlbumId(id);
        setCurrentItemAsAlbum(isAlbum);
        setCurrentItemPublished(status==='Published' || status==='Publicado')
    };

    
    const handleClickMenu_Go = (action) => {
        if (action != 'delete' && action != 'publish'){
            navigate('/addalbum', 
                {
                    state: {
                        action: action,
                        selectedAlbumId: currentAlbumId || -1,
                        isAlbum: 
                            action==='addalbum'
                                ? true
                                : action==='addsong'
                                    ? false
                                    : currentItemAsAlbum
                    }
                }
            );
        }
        else if (action==='delete')
            setShowConfirmDelete(true);
        else if (action==='publish')
            setShowConfirmPublish(true);
    }

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };


    const handleClick_Question = (answer) => {
        setOpen(false);
        switch(answer)
        {
            case "singleSong":
                navigate("/addsinglesong");
                break;
            case "album":
                navigate("/addalbum");
                break;
            default:
                break;
        }
    }


    const handleViewMessages = (albumId, albumName, disable) => {
        setCurrentAlbumId(albumId);
        setCurrentAlbumName(albumName);
        setCurrentAlbumDisabled(disable);
        setShowMessagesPopup(true);

        setRows(
            rows.map( obj => obj.albumId === albumId ? { ...obj, numSongsNotSeen:0} : obj)
        );
    }


    useEffect(()=>{
        getAlbumList(null)
            .then((rsp) => {
                setRows(rsp.metadata)
            })
    }, [])


    return(
        <>
            <BodyMain>
                <h2>{t("songs.pageTitle")}</h2>
                <Stack direction='row' sx={{mb:2}}>
                    <Button variant="text" sx={{ ...constants.styles.linkButton, fontWeight: 'bold' }} onClick={()=>handleClickMenu_Go('addalbum')}>{t("songs.option1")}</Button> 
                    <Typography sx={{mt:0.5}}>&nbsp;&nbsp;|&nbsp;&nbsp;</Typography>
                    <Button variant="text" sx={{ ...constants.styles.linkButton, fontWeight: 'bold' }} onClick={()=>handleClickMenu_Go('addsong')}>{t("songs.option2")}</Button>
                </Stack>
                <Box sx={{ 
                    width: '100%',
                    '& .alternateClass': {
                        backgroundColor: '#f2f2f2',
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .rowClass': {
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .alternateClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                    '& .rowClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <DataGrid
                            getRowId={(row) => row.albumId}
                            getRowHeight={() => 'auto'}
                            rows={rows}
                            columns={columns}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10,
                                    },
                                },
                                density: 'compact',
                            }}
                            getRowClassName ={
                                (params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'alternateClass' : 'rowClass'
                            }
                            pageSizeOptions={[5,10,20,{value:-1, label:'Todo'}]}
                            checkboxSelection = {false}
                            disableRowSelectionOnClick
                            disableColumnMenu={false}
                            slots={{
                                toolbar: GridToolbar,
                            }}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                }
                            }}
                            localeText={
                                language === 'es' 
                                ? esES.components.MuiDataGrid.defaultProps.localeText
                                : enUS.components.MuiDataGrid.defaultProps.localeText
                            }
                            sx={{
                                '& .MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                                    color: '#667', 
                                    fontSize: '0.8rem',
                                },
                            }}
                        />
                    </div>
                    <div style={{fontSize:'11px', color:'red'}}>
                        <br />
                        <b>{t("songs.noteImportant")}</b> {t("songs.noteText")} 
                    </div>
                </Box>
            </BodyMain>

            <Menu 
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                onClose={handleCloseMenu}
                onClick={handleCloseMenu}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 120,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => handleClickMenu_Go('view')} sx={{display: currentItemPublished ? '' : 'none'}}>
                    <VisibilityIcon sx={{marginRight:'15px'}} />
                    {t("songs.gridMenu1")}
                </MenuItem>
                <Divider sx={{display: currentItemPublished ? '' : 'none'}} />
                <MenuItem onClick={()=> handleClickMenu_Go('edit')} disabled={currentItemPublished}>
                    <EditIcon sx={{marginRight:'15px'}} />
                    {t("songs.gridMenu2")}
                </MenuItem>
                <MenuItem onClick={()=> handleClickMenu_Go('delete')} disabled={currentItemPublished}>
                    <DeleteForeverRoundedIcon sx={{marginRight:'15px'}} />
                    {t("songs.gridMenu3")}
                </MenuItem>
                {/* <Divider />
                <MenuItem onClick={()=> handleClickMenu_Go('publish')} disabled={currentItemPublished}>
                    <SendOutlinedIcon sx={{marginRight:'15px'}} />
                    {t("songs.gridMenu4")}
                </MenuItem> */}
            </Menu>
            <Confirmation title={t("songs.confirmTitle")} content={t("songs.confirmContent")}
                open={showConfirmDelete} onClose={()=>setShowConfirmDelete(false)} 
                onResponse={handleDelete} />
            <Confirmation title={t("songs.confirmTitlePublish")} content={t("songs.confirmContentPublish")}
                open={showConfirmPublish} onClose={()=>setShowConfirmPublish(false)} 
                onResponse={handlePublish} />

            <Chat open={showMessagesPopup} albumId={currentAlbumId} albumName={currentAlbumName} disableChat={currentAlbumDisabled} onClose={()=>setShowMessagesPopup(false)} />
        </>
    );
}

export default Songs;